<template>
  <game-layout
    :clue="!gameEnded"
    :activeClue="hasClues"
    :score="score"
    class="fill-height d-flex pb-md-8"
    :class="{
      'answer-success': (showAnswer && success),
      'answer-error': (showAnswer && !success),
      'success lighten-4': gameEnded,
    }"
    @clue="clue()"
    @close="$track('game_leave', 'rondo')"
  >
    <div class="fill-height d-flex pb-md-16">
      <!-- @clue="showClue = true" -->
      <!-- :activeClue="!$store.state.rondo.currentClue" -->
      <!-- Loading screen -->
      <BaseLoader v-if="loading" />

      <!-- Game over screen -->
      <RondoGameOver v-else-if="gameEnded" />

      <!-- Game screen -->
      <div v-else class="py-4 rondo">
        <div class="text-center my-4 pb-8" v-if="isClassMode">
          <span
            class="px-6 py-3 rounded-xl"
            :class="colorClass($store.getters['classMode/rondoCurrentTeam'] - 1)"
          >
            {{ $t('GAME.RONDO.CLASS_MODE.PLAYING_TEAM') }}
            {{ $store.getters['classMode/rondoCurrentTeam'] }}
          </span>
        </div>

        <div class="top-section d-flex flex-column align-end mt-4 ml-6">
          <BaseAvatar size="64" class="avatar-inside" />
          <GameRondo :class="{
            'rondo-small': $vuetify.breakpoint.smAndDown,
            'rondo-big': $vuetify.breakpoint.mdAndUp,
          }" />
          <NearQuestions class="hidden-md-and-up" />
          <QuestionStartContains
            v-if="!showAnswer"
            class="mr-6 hidden-md-and-up"
          />
        </div>

        <div class="game-content px-6">
          <div class="d-flex justify-center mb-4">
            <QuestionStartContains
              v-if="!showAnswer"
              class="hidden-sm-and-down"
            />
          </div>

          <div class="question">
            <QuestionCard />
          </div>

          <div class="word text-center">
            <WordGuess
              v-model="guess"
              :show-answer="showAnswer"
            />
          </div>

          <div v-if="!showAnswer && showButtons" class="buttons">
            <v-btn
              large
              block
              rounded
              color="primary"
              :disabled="!checkEnabled"
              @click="check"
            >
              {{ $t('GAME.RONDO.CHECK') }}
            </v-btn>
            <v-btn
              large
              block
              rounded
              outlined
              color="primary"
              class="mt-2"
              @click="$track('rondo_skip', 'rondo', answer); next(true)"
            >
              {{ $t('GAME.RONDO.SKIP') }}
            </v-btn>
          </div>
          <div v-else-if="showAnswer">
            <v-btn
              block
              rounded
              class="mt-2"
              :class="(success) ? 'success darken-2' : 'error'"
              @click="next()"
            >
              {{ $t('GAME.RONDO.NEXT') }}
            </v-btn>
          </div>
        </div>
      </div>

      <RondoCreateTeams
        v-if="isClassModeCreator"
        v-model="classTeamsModal"
      />
        <!-- v-else -->
      <RondoTeamSelect
        v-model="rondoTeamSelect"
      />
    </div>
  </game-layout>
</template>

<style scoped>
.answer-success {
  background: var(--v-success-lighten5);
}
.answer-error {
  background: var(--v-primary-lighten5);
}

.top-section {
  position: relative;
  height: 160px;
}

.avatar-inside {
  position: absolute;
  left: 40px;
  top: 40px;
}

.rondo-big {
  transform-origin: left top;
  transform: scale(1);
  position: absolute;
  left: 30px;
}

.rondo-small {
  transform-origin: left top;
  transform: scale(.4);
  position: absolute;
  left: 0;
}

/* xs */
@media screen and (max-width: 410px) {
  .top-section {
    height: 110px;
  }

  .rondo-small {
    transform: scale(.25);
  }

  .avatar-inside {
    position: absolute;
    left: 13px;
    top: 13px;
  }
}

/* md and up */
@media screen and (min-width: 960px) {
  .rondo {
    max-width: 950px;
    margin: auto;
  }

  .avatar-inside {
    left: 175px;
    top: 140px;
  }

  .top-section {
    height: 0px;
  }

  .game-content {
    margin-left: 450px;
    max-width: 470px;
  }
}

</style>

<script>
import GameLayout from '@/layouts/GameLayout.vue';

import NearQuestions from '@/components/games/rondo/NearQuestions.vue';
import GameRondo from '@/components/games/rondo/GameRondo.vue';
import QuestionStartContains from '@/components/games/rondo/QuestionStartContains.vue';
import QuestionCard from '@/components/games/rondo/QuestionCard.vue';
import WordGuess from '@/components/games/rondo/WordGuess.vue';
// import RondoClue from '@/components/games/rondo/RondoClue.vue';
import RondoGameOver from '@/components/games/rondo/RondoGameOver.vue';
import RondoTeamSelect from '@/components/games/rondo/RondoTeamSelect.vue';
import RondoCreateTeams from '@/components/games/rondo/RondoCreateTeams.vue';

import removeAccents from '@/helpers/removeAccents';

export default {
  name: 'Rondo',
  components: {
    GameLayout,
    NearQuestions,
    GameRondo,
    QuestionStartContains,
    QuestionCard,
    WordGuess,
    // RondoClue,
    RondoGameOver,
    RondoTeamSelect,
    RondoCreateTeams,
  },
  data: () => ({
    guess: '',
    showAnswer: false,
    success: null,
    showClue: false,
    polling: null,
  }),
  computed: {
    loading() {
      return this.$store.state.rondo.loading;
    },
    classTeamsModal() {
      const teams = this.$store.state.classMode.rondoTeams;
      const teamsSelected = teams !== null && teams > 0;
      return this.isClassMode && !teamsSelected;
    },
    rondoTeamSelect() {
      let teamSelected = this.$store.state.classMode.rondoTeam > 0;
      // Team creator don't need to chose team
      if (this.isClassModeCreator) {
        teamSelected = true;
      }

      return this.isClassMode && !teamSelected;
    },
    question() {
      return this.$store.getters['rondo/current'];
    },
    checkEnabled() {
      if (this.answer.length !== this.guess.length) {
        return false;
      }
      return true;
    },
    answer() {
      return (this.question && this.question.word.toUpperCase()) || '';
    },
    gameEnded() {
      return this.$store.state.rondo.gameEnded;
    },
    cluesOver() {
      return this.$store.state.rondo.cluesOver;
    },
    hasClues() {
      return !this.gameEnded && !this.cluesOver;
    },
    score() {
      if (this.isClassMode) {
        return this.$store.getters['classMode/score']('rondo');
      }

      return this.gameEnded ? ' ' : this.$store.getters['rondo/score'];
    },
    currentTeamTurn() {
      return this.$store.getters['classMode/rondoCurrentTeam'];
    },
    myTeam() {
      return this.$store.state.classMode.rondoTeam;
    },
    showButtons() {
      if (!this.isClassMode) {
        return true;
      }

      return this.isClassModeCreator || this.currentTeamTurn === this.myTeam;
    },
  },
  methods: {
    next(skip) {
      // Reset state
      this.guess = '';
      this.showAnswer = false;
      this.success = null;
      this.$store.dispatch('rondo/next');
      if (this.isClassMode && skip) {
        this.$store.dispatch('classMode/rondoChange', this.$store.state.rondo.current);
      } else if (this.isClassMode) {
        this.$store.dispatch('classMode/rondoChangeChar', this.$store.state.rondo.current);
      }
    },
    check() {
      const answer = removeAccents(this.answer);
      const guess = removeAccents(this.guess);
      const success = (answer === guess);

      this.showAnswer = true;
      this.success = success;

      this.$store.dispatch('rondo/answer', {
        success,
        id: this.question.id,
        classMode: this.isClassMode,
      });

      if (success) {
        this.$track('game_success', 'rondo', this.answer);
      } else {
        this.$track('game_error', 'rondo', this.answer);
      }
    },
    clue() {
      this.$store.dispatch('rondo/clue', {
        classMode: this.isClassMode,
      });
      this.$track('rondo_clue', 'rondo', this.answer);
    },
    startPolling() {
      this.polling = setInterval(() => {
        this.$store.dispatch('rondo/get', {
          classMode: this.$store.state.classMode.session,
          polling: true,
        });
      }, 5000);
    },
  },
  created() {
    const list = this.$store.state.rondo.list[this.$i18n.locale];
    const emptyStore = list && Object.keys(list).length === 0;
    if (emptyStore || this.gameEnded || this.isClassMode) {
      let ops = {};
      if (this.isClassMode) {
        ops = { classMode: this.$store.state.classMode.session };
        this.startPolling();
      }
      this.$store.dispatch('rondo/get', ops);
    }

    // On first play, show tutorial
    const showTutorial = !this.$store.state.settings.preEvaluatedRondo;
    if (!this.isClassMode && showTutorial) {
      this.$router.replace({ name: 'rondoTutorial' });
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>
